import type { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';
import { createContext } from 'react';

const MobileNavContext = createContext<{ primaryLinkId?: PrimaryNavIdentifier }>({});

export default MobileNavContext;
